import { Text, chakra } from '@chakra-ui/react';
import { openExternalUrl } from '@/utils/openUrl';

const TERMS_URL = 'https://www.volyx.app/terms-conditions.html';

/** Consent line shown under the Google/Apple buttons on the login and signup pages. */
export function OAuthTermsNotice() {
  return (
    <Text fontSize="xs" color="volyx.textSecondary" textAlign="center" lineHeight="tall">
      By continuing with Google or Apple, you agree to our{' '}
      <chakra.a
        href={TERMS_URL}
        color="volyx.primary"
        fontWeight="semibold"
        textDecoration="underline"
        cursor="pointer"
        _hover={{ opacity: 0.8 }}
        onClick={(e: React.MouseEvent) => {
          e.preventDefault();
          e.stopPropagation();
          openExternalUrl(TERMS_URL);
        }}
      >
        Terms and Conditions
      </chakra.a>
      .
    </Text>
  );
}
